import { render, staticRenderFns } from "./TipsInfo.vue?vue&type=template&id=d234df70&scoped=true&"
import script from "./TipsInfo.vue?vue&type=script&lang=ts&"
export * from "./TipsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TipsInfo.vue?vue&type=style&index=0&id=d234df70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d234df70",
  null
  
)

export default component.exports